import axios from 'axios'
import config from './config'
import store from '../store/index'
import methods from './methods'
import {
    message,
    Modal
} from 'ant-design-vue';
import {
    Base64
} from 'js-base64'
//登录提示框提示次数状态（只提示一次）
let loginOutStatus = true

let numRequest = {}
// 请求拦截器
axios.interceptors.request.use(function (requst) {
    if (requst.headers.loading_flag) {
        numRequest[requst.url] = numRequest[requst.url] ? numRequest[requst.url] + 1 : 1
    }
    delete requst.headers.loading_flag
    if (Object.keys(numRequest).length > 0) {
        store.state.loading_state = true;
    }
    return requst;
}, function (error) {});
// 响应拦截器
axios.interceptors.response.use(function (response) {
    const r_config = response.config
    if (numRequest[r_config.url]) {
        if (numRequest[r_config.url] > 1) {
            numRequest[r_config.url]--
        } else {
            delete numRequest[r_config.url]
        }
    }
    if (Object.keys(numRequest).length == 0) {
        store.state.loading_state = false;
    }
    return response;
}, function (error) {
    const e_config = error.config
    if (numRequest[e_config.url]) {
        if (numRequest[e_config.url] > 1) {
            numRequest[e_config.url]--
        } else {
            delete numRequest[e_config.url]
        }
    }
    if (Object.keys(numRequest).length == 0) {
        store.state.loading_state = false;
    }
});

function req({
    url = '',
    data = {},
    type = 'post',
    loading = false,
    loading_msg = '数据加载中...',
    toast = false,
    toastTime = 3,
    mode = 'api',
    errToast = true,
}) {
    if (loading) {
        store.state.loading_text = loading_msg;
    }
    return new Promise((resolve, reject) => {
        if (process.env.NODE_ENV === 'development') { // 本地代理处理
            url = '/apis' + url
        } else {
            if (url.charAt(0) != '/') {
                url = '/' + url
            }
            url = config.host + url;
        }
        let headers = {
            'Content-Type': 'application/json',
            'loading_flag': loading
        }
        headers.token = methods.getStorage('token')
        if (mode == 'upload') {
            headers['content-type'] = 'multipart/form-data';
            let form_data = new FormData();
            for (let key in data) {
                form_data.append(key, data[key]);
            }
            data = form_data;
        } else {
            let nowTime = new Date().getTime();
            nowTime = parseInt(nowTime / 1000)
            data.sign_time = nowTime
            //将参数转为json字符串
            headers.sign = methods.setMd5Data(JSON.stringify(data) + 'LeaRningWeb@20260724!')
        }
        //发送请求
        axios({
            method: type,
            url: url,
            headers,
            data: data,
        }).then(res => {
            //处理返回数据
            res = res.data
            if (res.code == 1) {
                resolve(res.data)
                if (toast) {
                    message.success(res.info || res.msg, toastTime)
                }
            } else if (res.code == -2) {
                methods.setStorage('token', '')
                if (loginOutStatus) {
                    loginOutStatus = false
                    Modal.warning({
                        title: '温馨提示',
                        content: '账号已失效，请重新登录~',
                        okText: '去登录',
                        onOk() {
                            loginOutStatus = true
                            location.href = process.env.BASE_URL + 'login'
                        }
                    });
                }
            } else if (res.code == 0) {
                if (errToast) {
                    message.error(res.info || res.msg, toastTime)
                }
                reject(res)
            } else {
                reject(res)
            }
        }).catch(e => {
            reject(e)
        })
    })
}

export default req;